import * as React from 'react';
import { MessageDescriptor } from 'react-intl';

import {
  DiscountIcon,
  TagModel,
  TruckIcon,
  StarIcon,
  ProductTileModel,
} from '@notino/react-styleguide';

import messages from '@containers/ProductDetailContainer/messages';
import {
  AttributeTypes,
  AttributeType,
} from '@containers/ProductListing/model';

export interface ILabelAttribute {
  icon: JSX.Element;
  style: TagModel.Styles;
  tooltipMessage?: MessageDescriptor;
}

export enum ClientOnlyAttributeTypes {
  Damaged = 'Damaged',
  Returned = 'Returned',
}

export type ILabelAttributes = {
  [key in ProductTileModel.TagAttributes]: ILabelAttribute;
};

/** Label attributes definition */
export const labelAttributes: Omit<
  ILabelAttributes,
  ProductTileModel.TagAttributes.Gift
> = {
  [AttributeTypes.Action]: {
    style: TagModel.Styles.primary,
    icon: <DiscountIcon />,
  },
  [AttributeTypes.FreeDelivery]: {
    style: TagModel.Styles.neutral,
    icon: <TruckIcon />,
  },
  [AttributeTypes.New]: {
    style: TagModel.Styles.muted,
    icon: <StarIcon />,
  },
  [AttributeTypes.Clearance]: {
    style: TagModel.Styles.primary,
    icon: <DiscountIcon />,
  },
  [ClientOnlyAttributeTypes.Damaged]: {
    style: TagModel.Styles.muted,
    icon: <DiscountIcon />,
    tooltipMessage: messages.productDamaged,
  },
  [ClientOnlyAttributeTypes.Returned]: {
    style: TagModel.Styles.muted,
    icon: <DiscountIcon />,
    tooltipMessage: messages.productReturned,
  },
};

export interface ITagsProps {
  attributes?: AttributeType;
  stockAvailability: string;
  small?: boolean;
  multiple?: boolean;
  type?: TagModel.Types;
  icon?: string;
  onClick?: (attribute: ProductTileModel.TagAttributes) => void;
  nowrapLg?: boolean;
}
